module.exports = __webpack_public_path__ + "img/ch37.1c41761a.png";